
export const themeColorChanger = (colorId) => {
    if (!colorId) return null;
    localStorage.setItem('data-color-theme', colorId)
    document
        .body.parentNode
        .setAttribute('data-color-theme', colorId)
}

export const themeColorGetter = ({isStrong} = {}) => {
    const theme = localStorage.getItem('data-color-theme')
    if (isStrong) return theme;
    return theme || "violet"
}